module.exports = __webpack_public_path__ + "img/db_03.8417e96f.png";